module.exports = __webpack_public_path__ + "static/media/finals-1.b9faac9d.png";